import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        axiosCancelArr:[],
    },
    mutations: {
        PUSH_CANCEL(state, cancel){
            state.axiosCancelArr.push(cancel.cancelToken);
          },
      
          CLEAR_CANCEL(state){
            state.axiosCancelArr.forEach(e=>{
              e && e()
            });
            state.axiosCancelArr = []
          }
    },
    actions:{
        pushCancel({commit}, cancel){
          commit('PUSH_CANCEL', cancel)
        },
        clearCancel({commit}){
          commit('CLEAR_CANCEL');
        }
      }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js